<template>
	<div id="wrapper">
		<RTHeader/>
		<RTNavigation/>
		<div id="main">
			<div class="inner">
				<header>
					<p><router-link to="/" class="body-2 font-weight-bold">zurück zur Übersicht</router-link></p>
				<h1>Unternehmen eintragen</h1>
				<p v-if="!submitted">
					Du bist vom Round Table | Ladies Circle | Old Tablers | Tangent Club und möchtest in die Übersicht mit aufgenommen werden, dann trage Dich in das nachstehende Formular ein.
				</p>
				</header>
				<section v-if="!submitted">
					<form id="form_new_entry" @submit.stop.prevent="onSubmitted" method="post" :action="postUrl">
						<div class="row gtr-uniform">
							<h2 class="col-12 mb-1">Daten zum Unternehmen / Produkt</h2>

							<!-- Portfolio -->
							<div class="col-6 col-12-xsmall">
								<input type="text" name="title" id="form-title" v-model="title" placeholder="Überschrift" maxlength="50">
								<p class="form-descr second-color">Eine kurze, prägnante Überschrift repräsentiert dein Portfolio und damit deine Verlinkung zu deinem Unternehmen / Produkt.</p>
							</div>
							<div class="col-6 col-12-xsmall">
								<input type="text" name="company" id="form-company" v-model="company"  placeholder="Unternehmen" maxlength="50">
								<p class="form-descr second-color">Wie heißt dein Unternehmen?</p>
							</div>
							<div class="col-12">
								<input type="text" name="url" id="form-url" v-model="url"  placeholder="Link zum Online-Shop / Link zur Webseite">
								<p class="form-descr second-color">Welche Webseite soll verlinkt werden? Beispiel: https://www.vontablern.de</p>
							</div>
							<div class="col-12">
								<input type="text" name="descr" id="form-descr" v-model="descr"  placeholder="Kurzbeschreibung zum Unternehmen oder Produkt" maxlength="120">
								<p class="form-descr second-color">Wofür steht dein Unternehmen ? Welches Produkt bietest du an? (Max: 120 Zeichen)</p>
							</div>

							<!-- Image -->
							<div class="col-12">
								<vue-dropzone ref="myVueDropzone" id="dropzone" @vdropzone-sending="sendingEvent" @vdropzone-success="onUploadSuccess" @vdropzone-error="onUploadError" :options="dropzoneOptions"></vue-dropzone>
								<p class="form-descr second-color">Welches Bild soll als Coverfoto in deinem Portfolio dargestellt werden?</p>
							</div>

							<!-- Top Kategorien  -->
							<div class="col-3 col-6-small">
								<input type="checkbox" id="top-category-products" v-model="selectedTopCatIds[0]" name="top-category-products">
								<label for="top-category-products">Produkte</label>
							</div>
							<div class="col-3 col-6-small">
								<input type="checkbox" id="top-category-dienstleistung" v-model="selectedTopCatIds[1]" name="top-category-dienstleistung">
								<label for="top-category-dienstleistung">Dienstleistung</label>
							</div>
							<div class="col-3 col-6-small">
								<input type="checkbox" id="top-category-overnight" v-model="selectedTopCatIds[2]" name="top-category-overnight">
								<label for="top-category-overnight">Übernachtung</label>
							</div>
							<div class="col-3 col-6-small">
								<input type="checkbox" id="top-category-others" v-model="selectedTopCatIds[3]" name="top-category-others">
								<label for="top-category-others">Sonstiges</label>
							</div>
							<div class="pt-0 col-12"><p class="form-descr second-color">Welche Leistung bietest du überwiegend an?</p></div>
							

							<!-- Categories -->
							<div class="row">
								
								<div class="col-4 col-12-xsmall">
									<!-- <multiselect v-model="selectedCategories" tag-placeholder="Add this as new tag" placeholder="Search or add a tag" label="name" track-by="id" :options="sortedCategories" :multiple="true" :taggable="true" :max="3" :hideSelected="true"></multiselect>-->
									<select name="category" id="category1" v-model="selectedCatIds[0]">
										<option value="0">1. Branche wählen</option>
										<option v-for="(cat,index) in sortedCategories" :key="index" :value="cat.id">{{cat.name}}</option>
									</select>
								</div>
								<div class="col-4 col-12-xsmall">
									<select name="category" id="category2" v-model="selectedCatIds[1]">
										<option value="0">2. Branche wählen</option>
										<option v-for="(cat,index) in sortedCategories" :key="index" :value="cat.id">{{cat.name}}</option>
									</select>
								</div>
								<div class="col-4 col-12-xsmall">
									<select name="category" id="category3" v-model="selectedCatIds[2]">
										<option value="0">3. Branche wählen</option>
										<option v-for="(cat,index) in sortedCategories" :key="index" :value="cat.id">{{cat.name}}</option>
									</select>
								</div>
							</div>
							<div class="pt-0 col-12"><p class="form-descr second-color">Wähle maximal 3 Kategorien, die zu deinem Unternehmen / Produkt passen.</p></div>
							
							<!-- Teaserbild -->

							<!-- Shipping -->
							<div class="col-2 col-6-small">
								<input type="checkbox" id="shipping-de" v-model="selectedShipIds[0]" name="shipping-de">
								<label for="shipping-de">DE</label>
							</div>
							<div class="col-2 col-6-small">
								<input type="checkbox" id="shipping-at" v-model="selectedShipIds[1]" name="shipping-at">
								<label for="shipping-at">AT</label>
							</div>
							<div class="col-2 col-6-small">
								<input type="checkbox" id="shipping-ch" v-model="selectedShipIds[2]" name="shipping-ch">
								<label for="shipping-ch">CH</label>
							</div>
							<div class="col-2 col-6-small">
								<input type="checkbox" id="shipping-eu" v-model="selectedShipIds[3]" name="shipping-eu">
								<label for="shipping-eu">EU</label>
							</div>
							<div class="col-3 col-6-small">
								<input type="checkbox" id="shipping-international" v-model="selectedShipIds[4]" name="shipping-international">
								<label for="shipping-international">International</label>
							</div>
											
							<div class="pt-05 col-12"><p class="form-descr second-color">Wohin versendest du deine Produkte bzw. wo bietest deine Dienstleistung an?</p></div>

							<!-- Tags -->
							<h2 class="mt-3 col-12 mb-1">Suchbegriffe / Tags</h2>
							<div class="col-12">
								<div
									class="tags-input-wrap"
									@click="$refs.tagInputField.focus()"
								>
									<span
										v-for="(tag, index) in tags"
										:key="'tag-' + index"
										class="tag-chip"
									>
										{{ tag }}
										<button
											type="button"
											class="tag-chip-remove"
											@click.stop="removeTag(index)"
											aria-label="Tag entfernen"
										>×</button>
									</span>
									<input
										ref="tagInputField"
										type="text"
										class="tags-real-input"
										v-model="tagInput"
										:placeholder="tags.length === 0 ? 'Tag eingeben…' : (tags.length >= TAG_MAX ? 'Max. ' + TAG_MAX + ' erreicht' : '')"
										:disabled="tags.length >= TAG_MAX"
										maxlength="40"
										autocomplete="off"
										@keydown="onTagKeydown"
										@blur="onTagBlur"
									>
								</div>
								<p class="form-descr second-color">
									Füge bis zu {{ TAG_MAX }} Tags hinzu - z.B. <em>handgemacht, bio, nachhaltig</em>. Enter oder Komma zum Bestatigen.
									<span v-if="tags.length > 0" class="tags-counter">{{ tags.length }}/{{ TAG_MAX }}</span>
								</p>
							</div>

							<!-- Personal -->
							<h2 class="mt-3 col-12 mb-1">Persönliche Angaben (Kontakt)</h2>
							<div class="pt-05 col-12"><p class="form-descr second-color">Wie können dich andere Ladies / Tabler erreichen? Diese Angaben sind innerhalb deines Portfolios öffentlich für andere einsehbar.</p></div>
							<div class="col-6 col-12-xsmall">
								<input type="text" name="name" id="form-name" v-model="name" placeholder="Vor- und Nachname">
							</div>
							<div class="col-6 col-12-xsmall">
								<input type="text" name="nr" id="form-nr" v-model="nr" placeholder="Tisch / Circle Nummer">
							</div>
							<div class="col-6 col-12-xsmall">
								<input type="email" name="email" id="form-email" v-model="email" placeholder="E-Mail-Adresse">
							</div>
							<div class="col-6 col-12-xsmall">
								<input type="text" name="tel" id="form-tel" v-model="tel" placeholder="Telefonnummer (optional)">
							</div>

							<!-- Herkunft / Country -->
							<!-- Shipping -->
							<div class="col-3 col-12-small">Ansässig in: </div>
							<div class="col-3 col-12-small">
								<input type="radio" id="country-de" checked="checked" value="de" @click="country=1" name="country">
								<label for="country-de">Deutschland</label>
							</div>
							<div class="col-3 col-12-small">
								<input type="radio" id="country-at" value="at" @click="country=2" name="country">
								<label for="country-at">Österreich</label>
							</div>
							<div class="col-3 col-12-small">
								<input type="radio" id="country-ch" value="ch" @click="country=3" name="country">
								<label for="country-ch">Schweiz</label>
							</div>


							<!-- Feedback -->
							<h2 class="mt-3 col-12 mb-0">Feedback</h2>
							<div class="col-12 pt-05">
								<div class="textarea-wrapper">
									<textarea name="form-feedback" id="form-feedback" v-model="feedback" placeholder="" rows="1" style="overflow: hidden; resize: none; height: 69px;"></textarea>
									<div class="pt-05 col-12"><p class="form-descr second-color">Mochtest du uns etwas sagen oder einfach nur ein Danke hinterlassen, dann ist das die richtige Stelle.</p></div>
								</div>
							</div>

							<!-- Fehler-Meldungen -->
							<div v-if="error" class="pt-05 col-12">
								<p class="form-error">
									Es ist leider ein Fehler aufgetreten. Bitte versuche es nocheinmal.
									<span v-if="errorMessage" class="form-error-detail">{{ errorMessage }}</span>
									<span class="form-error-hint">Klappt es weiterhin nicht? Schreib mir direkt uber das Kontaktformular auf der Hauptseite.</span>
								</p>
							</div>
							<div v-if="hasEmptyField" class="pt-05 col-12">
								<p class="form-error">Wir benotigen das Feld „{{ emptyField }}“, um ein vollstandiges Profil anlegen zu konnen.</p>
							</div>

							<div class="field">
								<input type="checkbox" id="dsgvo-check" name="dsgvocheck" v-model="dsgvoChecked">
								<label for="dsgvo-check">Ich habe die <a href="#" @click.stop.prevent="showDatenschutzModal">Datenschutzbestimmungen</a> fur die Verarbeitung meiner personlichen Daten gelesen</label>
							</div>
							<div class="col-12">
								<ul class="actions">
									<input type="hidden" id="data" name="data" :value="dataAsString">
									<li class="w-100">
										<input
											type="submit"
											:value="submitting ? 'Wird eingetragen…' : 'Unternehmen jetzt eintragen'"
											:disabled="!dsgvoChecked || submitting"
											class="second-bgcolor primary fit"
										>
									</li>
								</ul>
							</div>
						</div>
					</form>
				</section>
				<section v-else>
					<div class="row gtr-uniform">
						<h2 class="second-color col-12 mb-1">Perfekt. Geschafft.</h2>
						<p>
							<section>
							<p>Ich werde nun deinen Eintrag überprüfen und schnellstmöglich online stellen. Schön, dass du dabei bist. :-)</p>
							<p>Sollte dein Eintrag binnen 3 Tagen nicht online sein, dann schreib mir bitte eine Nachricht. </p>
							<p>YiT Tobias Hubold von RT210 Jena</p>
							</section>
							<RTdonate/>
							
						</p>
					</div>
				</section>
			</div>
		</div>
		<!-- Modals -->
		<RTmodal ref="datenschutzModal">
            <RTdatenschutz/>
        </RTmodal>
	</div>
</template>

<script>
import Vue from 'vue'
import RTHeader from '@/components/RTHeader.vue'
import RTNavigation from '@/components/RTNavigation.vue'
import RTmodal from '@/components/RTmodal.vue'
import RTdatenschutz from '@/components/RTdatenschutz.vue'
import RTdonate from '@/components/RTdonate.vue'

import {categoryBase} from '@/mixins/categoryBase.js'
import jsonShippings from '@/assets/shippings.json';
import jsonTopCategories from '@/assets/top_categories.json';
import jsonCountries from '@/assets/countries.json';
import {helper} from '@/mixins/helper.js'

import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'

export default {
	name: 'FormView',
	mixins: [helper, categoryBase],
	components: {
		RTHeader,
		RTNavigation,
		RTmodal,
		RTdatenschutz,
		RTdonate,
		vueDropzone: vue2Dropzone,
	},
	data() {
		return {
			title: "",
			company: "",
			url: "",
			descr: "",
			shipping: jsonShippings,
			topCategories: jsonTopCategories,
			countries: jsonCountries,
			selectedCatIds: [],
			selectedShipIds: [],
			selectedTopCatIds: [],
			name: "",
			email: "",
			tel: "",
			nr: "",
			country: 1,
			img: "",
			IMG_FOLDER: "/upload/",
			dsgvoChecked: false,
			submitted: false,
			submitting: false,   // FIX: separater Lade-State, verhindert doppeltes Absenden
			error: false,
			errorMessage: "",
			emptyField: null,
			// Tags
			tags: [],            // Array der aktuellen Tags
			tagInput: "",        // aktuell getippter Tag-Text
			TAG_MAX: 20,
			feedback:"",
			token: "jhsZZb5sb*#GbvxSms33DDfsI3#*Y9s",
			dropzoneOptions: {
				url: '/pro.php',
				maxFilesize: 5,
				maxFiles: 1,
				createImageThumbnails: false,
				dictDefaultMessage: "<i class='icon solid fa-image mr-1'></i>Coverfoto für dein Portfolio auswählen",
				resizeWidth: 1200,
				resizeQuality: 0.9,
				addRemoveLinks: true,
				acceptedFiles: "image/*",
			},
			postUrl: "/api.php",
		};
	},
	computed: {
		hasEmptyField() {
			return this.emptyField != null;
		},
		dataAsString() {
			return JSON.stringify(this.dataObject);
		},
		dataObject() {
			return {
				id: this.newUuid(),
				title: this.title.trim(),
				descr: this.descr.trim(),
				company: this.company.trim(),
				url: this.url.trim(),
				name: this.name.trim(),
				email: this.email.trim(),
				tel: this.tel.trim(),
				nr: this.nr.trim(),
				category: this.filterEmptyData(this.selectedCatIds),
				ship: this.getCorrectShippingData(this.selectedShipIds),
				top_cat: this.getCorrectTopCategoryData(this.selectedTopCatIds),
				country: this.country,
				img: this.img,
				tags: this.tags,   
				feedback: this.feedback.trim(),   
			};
		},
	},
	methods: {

		// ── TAGS ────────────────────────────────────────────────
		commitTagInput() {
			const raw = this.tagInput.trim().toLowerCase()
				.replace(/[,;]+/g, '')
				.substring(0, 40);
			if (!raw) return;
			if (this.tags.length >= this.TAG_MAX) return;
			if (this.tags.indexOf(raw) === -1) {
				this.tags.push(raw);
			}
			this.tagInput = "";
		},
		onTagKeydown(e) {
			// Enter oder Komma → Tag hinzufügen
			if (e.key === 'Enter' || e.key === ',' || e.key === ';') {
				e.preventDefault();
				this.commitTagInput();
			}
			// Backspace auf leerem Input → letzten Tag entfernen
			if (e.key === 'Backspace' && this.tagInput === '' && this.tags.length) {
				this.tags.pop();
			}
		},
		onTagBlur() {
			this.commitTagInput();
		},
		removeTag(index) {
			this.tags.splice(index, 1);
		},

		// ── VALIDATION ──────────────────────────────────────────
		hasValidPostData() {
			this.emptyField = null;
			if (!this.title.trim())   { this.emptyField = "Überschrift"; }
			else if (!this.company.trim()) { this.emptyField = "Unternehmen"; }
			else if (!this.url.trim())     { this.emptyField = "Link zum Online-Shop / Link zur Webseite"; }
			else if (!this.descr.trim())   { this.emptyField = "Kurzbeschreibung"; }
			else if (!this.name.trim())    { this.emptyField = "Name"; }
			else if (!this.nr.trim())      { this.emptyField = "Tisch / Circle Nummer"; }
			else if (!this.email.trim())   { this.emptyField = "E-Mail"; }
			return this.emptyField == null;
		},

		// ── DROPZONE ────────────────────────────────────────────
		sendingEvent(file, xhr, formData) {
			if (formData) {
				formData.append('token', this.token);
			}
		},
		onUploadSuccess(file, response) {
			// FIX: Pfad aus Server-Response lesen, nicht aus file.name
			// api.php / pro.php sollte { "filename": "img_xxx.jpg" } zurückgeben
			try {
				const res = typeof response === 'string' ? JSON.parse(response) : response;
				if (res && res.filename) {
					this.img = this.IMG_FOLDER + res.filename;
				} else if (res && res.path) {
					this.img = res.path;
				} else if (file && file.name) {
					// Fallback: lokaler Dateiname (nur wenn Server keinen Pfad liefert)
					this.img = this.IMG_FOLDER + file.name;
				}
			} catch (e) {
				if (file && file.name) {
					this.img = this.IMG_FOLDER + file.name;
				}
			}
		},
		onUploadError(file, message) {
			console.warn('[Dropzone] Upload-Fehler:', message);
		},

		// ── SUBMIT ──────────────────────────────────────────────
		async onSubmitted() {
			// Kein Doppel-Submit
			if (this.submitting) return;

			if (!this.hasValidPostData()) return;

			this.error = false;
			this.errorMessage = "";
			this.submitting = true;

			// Daten als JSON-Body senden (zuverlässiger als FormData mit hidden field)
			// dataObject enthält bereits alle relevanten Felder inkl. Tags
			const payload = new FormData();
			payload.append('data', JSON.stringify(this.dataObject));

			try {
				const response = await fetch(this.postUrl, {
					method: 'POST',
					body: payload,
				});

				// HTTP-Fehler (4xx, 5xx)
				if (!response.ok) {
					throw new Error(`Server antwortete mit Status ${response.status}`);
				}

				// Antwort parsen – auch wenn kein JSON kommt
				let data = null;
				const contentType = response.headers.get('content-type') || '';
				if (contentType.includes('application/json')) {
					data = await response.json();
				}

				// Explizit success:false abfangen
				if (data && data.success === false) {
					throw new Error(data.error || 'Unbekannter Fehler vom Server');
				}

				// FIX: submitted erst NACH erfolgreichem Fetch setzen
				this.submitted = true;

			} catch (err) {
				console.error('[Form] Submit-Fehler:', err);
				this.error = true;
				this.errorMessage = err.message || '';
				// FIX: submitted bleibt false → User sieht das Formular + Fehlermeldung
			} finally {
				this.submitting = false;
			}
		},

		showDatenschutzModal() {
			this.$refs.datenschutzModal.show();
		},
		getShipmentById(id) {
			return this._.find(this.shipping, ['id', (id + 1)]);
		},
		getTopCategorytById(id) {
			return this._.find(this.topCategories, ['id', (id + 1)]);
		},
		getCorrectShippingData(data) {
			let res = [];
			if (this._.isArray(data)) {
				data.forEach((e, k) => {
					if (e) {
						const ship = this.getShipmentById(k);
						if (ship) res.push(ship.id);
					}
				});
			}
			return res;
		},
		getCorrectTopCategoryData(data) {
			let res = [];
			if (this._.isArray(data)) {
				data.forEach((e, k) => {
					if (e) {
						const obj = this.getTopCategorytById(k);
						if (obj) res.push(obj.id);
					}
				});
			}
			return res;
		},
	},
	beforeRouteEnter: (to, from, next) => {
		next(() => {
			setTimeout(() => { window.scrollTo(0, 0); }, 300);
		});
	},
	mounted() {
		Vue.set(this.selectedCatIds, 0, "0");
		Vue.set(this.selectedCatIds, 1, "0");
		Vue.set(this.selectedCatIds, 2, "0");
	},
};
</script>


<style>
.dz-message{
	font-family: "Source Sans Pro", Helvetica, sans-serif!important;
}
</style>

<style scoped>
	.form-descr{
		font-style: italic;
	}
	.form-error{
		color:red;
		text-align: center;
		font-size: large;
	}
	.form-error-detail{
		display: block;
		font-size: .85em;
		margin-top: .25rem;
		opacity: .8;
	}
	.form-error-hint{
		display: block;
		margin-top: .5rem;
		font-size: .9em;
	}
	/* Tags Input */
	.tags-input-wrap{
		display: flex;
		flex-wrap: wrap;
		align-items: center;
		gap: .35rem;
		padding: .5rem .75rem;
		border: 1px solid #ccc;
		border-radius: 4px;
		min-height: 46px;
		cursor: text;
		background: #fff;
		transition: border-color .15s, box-shadow .15s;
	}
	.tags-input-wrap:focus-within{
		border-color: #888;
		box-shadow: 0 0 0 2px rgba(0,0,0,.08);
		outline: none;
	}
	.tag-chip{
		display: inline-flex;
		align-items: center;
		gap: .3rem;
		background: #e8e8f0;
		color: #333;
		border-radius: 999px;
		padding: .25rem .65rem .25rem .75rem;
		font-size: .82rem;
		white-space: nowrap;
		line-height: 1.4;
	}
	.tag-chip-remove{
		background: none;
		border: none;
		cursor: pointer;
		font-size: 1rem;
		line-height: 1;
		padding: 0;
		opacity: .55;
		color: inherit;
		display: flex;
		align-items: center;
		box-shadow:none;
	}
	.tag-chip-remove:hover{ opacity: 1; }
	.tags-real-input{
		border: none;
		outline: none;
		font-family: inherit;
		font-size: 1rem;
		color: inherit;
		background: transparent;
		flex: 1;
		min-width: 100px;
		padding: .1rem .15rem;
	}
	.tags-real-input:disabled{ cursor: not-allowed; opacity: .5; }
	.tags-counter{
		display: inline-block;
		margin-left: .5rem;
		font-size: .85em;
		opacity: .7;
		font-style: normal;
	}
</style>